import {h} from "vue";
import * as allIcons from "@ant-design/icons-vue"

const icons: Record<string, any> =allIcons

allIcons.setTwoToneColor("#1DA57A")

type FCProps = {
    type: string;
    twoToneColor:string;
    spin:boolean;
}

export function Icon(
    props: FCProps,
) {
    return  icons[props.type] ? h(icons[props.type], props) : h(icons['QuestionOutlined'], props)
}

Icon.props = {
    type: {
        type: String,
        require: true,
    },
    twoToneColor: String,
    spin: Boolean,
}
